// Shipping English translations
export const shippingEn = {
  'add.prepaid.record': 'Add Prepaid Record',
  'add.repair.record': 'Add Repair Record',
  'add.shipping.price': 'Add Shipping Price',
  'add.shipping.record': 'Add Shipping Record',
  'advance': 'Advance',
  'advance.payment': 'Advance Payment',
  'auto.calculate.all.costs': 'Automatic Cost Calculation',
  'back.to.shipping': 'Back to Shipping',
  'back.to.shipping.records': 'Back to Shipping Records',
  'calculate.costs': 'Calculate Costs',
  'confirm.delete.shipping.price': 'Are you sure you want to delete this shipping price? This action cannot be undone.',
  'create.shipping.record': 'Create Shipping Record',
  'delivery.note.image': 'Delivery Note Image',
  'edit.prepaid.record': 'Edit Prepaid Record',
  'edit.repair.record': 'Edit Repair Record',
  'edit.shipping.price': 'Edit Shipping Price',
  'edit.shipping.record': 'Edit Shipping Record',
  'error.deleting.shipping.price': 'Error deleting shipping price',
  'link.prepaid.record': 'Link Prepaid Record',
  'link.repair.receipt': 'Link Repair Receipt',
  'linked.prepaid.records': 'Linked Prepaid Records',
  'linked.repair.records': 'Linked Repair Records',
  'no.prepaid.records.linked': 'No prepaid records linked',
  'no.repair.records.found': 'No repair records found.',
  'no.repair.records.linked': 'No repair records linked',
  'no.shipping.records.found': 'No shipping records found.',
  'no.unlinked.prepaid.records': 'No unlinked prepaid records available',
  'no.unlinked.repair.records': 'No unlinked repair records available',
  'prepaid.amount': 'Prepaid Amount',
  'prepaid.date': 'Prepaid Date',
  'prepaid.records': 'Prepaid Records',
  'ready.to.calculate': 'Ready to calculate all fees automatically',
  'recent.repairs': 'Recent Repairs',
  'repair': 'Repair',
  'repair.cost': 'Repair Cost',
  'repair.costs': 'Repair Costs',
  'repair.date': 'Repair Date',
  'repair.records': 'Repair Records',
  'repair.shop': 'Repair Shop',
  'select.prepaid.record.to.link': 'Select a prepaid record to link',
  'select.repair.record.to.link': 'Select a repair record to link',
  'select.vehicle.date.province.first': 'Please select vehicle, shipping date, and province first',
  'select.vehicle.date.province.to.calculate': 'Select vehicle, shipping date, and province to calculate all costs automatically',
  'shipping.address': 'Shipping Address',
  'shipping.cost': 'Shipping Cost',
  'shipping.date': 'Shipping Date',
  'shipping.price.deleted.successfully': 'Shipping price deleted successfully',
  'shipping.prices': 'Shipping Prices',
  'shipping.prices.history': 'Shipping Prices History',
  'shipping.profit': 'Shipping Profit',
  'shipping.record': 'Shipping Record',
  'shipping.records': 'Shipping Records',
  'shipping.revenue': 'Shipping Revenue',
  'total.prepaid.amount': 'Total Prepaid Amount',
  'total.repair.cost': 'Total Repair Cost',
  'total.repairs': 'Total Repairs',
  'total.shipping.records': 'Total Shipping Records',
  'view.shipping.records': 'View Shipping Records',
  'will.calculate.driver.salary': 'Driver Salary',
  'will.calculate.loading.fee': 'Loading Fee',
  'will.calculate.rm2': 'RM2 Fee',
  'will.calculate.shipping.cost': 'Shipping Cost',
  'will.calculate.toll.fee': 'Toll Fee',

  // Shipping Price by Capacity (Matrix)
  'shipping.price.matrix': 'Shipping Price by Capacity',
  'shipping.price.capacity.history': 'Shipping Price by Capacity - History',
  'capacity': 'Capacity',
  'all.capacities': 'All Capacities',
  'tons': 'T',
  'all.provinces': 'All Provinces',
  'all.districts': 'All Districts',
  'location.type': 'Location Type',
  'reason.for.changes': 'Reason for Changes',
  'enter.reason': 'Enter reason for price changes...',
  'no.changes.to.save': 'No changes to save',
  'changes.saved.successfully': 'Changes saved successfully!',
  'error.saving.changes': 'Error saving changes',
  'confirm.discard.changes': 'Discard all unsaved changes?',
  'discard.changes': 'Discard Changes',
  'unsaved.changes': 'Unsaved changes',
  'no.price.set': 'No price set (will use province price if available)',
  'no.data.found': 'No data found. Try changing the filters.',
  'view.history': 'View History',
  'old.price': 'Old Price',
  'new.price': 'New Price',
  'changed.by': 'Changed By',
  'no.history.found': 'No history records found',
  'refresh': 'Refresh',
  'created': 'Created',
  'updated': 'Updated',
  'deleted': 'Deleted',
  'price.by.capacity': 'Price by Capacity',
  
  // Shipping Price by Capacity Matrix - additional
  'base.price': 'Base Price',
  'base.price.explanation': 'Base prices (shown in light blue) apply to all vehicle capacities. Edit a cell to create a capacity-specific override (shown in white). Overrides take priority when calculating shipping costs.',
  'how.it.works': 'How it works',
  'using.base.price': 'Using base price',
  'custom.override': 'Custom override',
  'no.base.prices.found': 'No base prices found. Please add locations in the Shipping Prices page first.',

  // Shipping date warning
  'shipping.date.warning': 'Warning: The shipping date ({shippingDate}) differs from today ({today}) by more than 1 day. AI may have read the date incorrectly from the image. Are you sure the shipping date is correct?',
  'shipping.date.warning.title': 'Shipping Date Warning',
  'shipping.date.confirm': 'Yes, Date is Correct',
};
